import React, { useState } from "react";

// APP COMPONENTS
import { orderTypesFrame } from "../../common/frames";

// MATERIAL UI COMPONENTS
import {
  AutocompleteStyledPaper,
  AutocompleteStyledPopper,
  StyledAutocomplete,
} from "../styled/inputs/autocomplete";
import { StyledTextField } from "../styled/inputs/textInput";

const OrderTypeFilter = ({ selectedValue, onFilterChange }) => {
  const [types, setTypes] = useState(orderTypesFrame);

  return (
    <StyledAutocomplete
      disablePortal={false}
      id="order-type-values"
      options={types}
      getOptionLabel={(option) => option.label}
      groupBy={(option) => option.firstLetter}
      renderInput={(params) => (
        <StyledTextField
          {...params}
          label="Tipo do Pedido"
          variant="outlined"
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
      PopperComponent={(props) => <AutocompleteStyledPopper {...props} />}
      PaperComponent={(props) => <AutocompleteStyledPaper {...props} />}
      onChange={(event, values) => {
        onFilterChange(values);
      }}
      sx={{ mb: 1 }}
    />
  );
};

OrderTypeFilter.displayName = "Tipo do Pedido";

export default OrderTypeFilter;
